<template>
  <m-tab>
    <b-row class="top-row">
      <b-col>

        <div class="m-tab-top-box">Choose the type of geographic area you wish to use to target your prospects
        </div>
      </b-col>
      <b-col>
      <div class="top-btn">
        <b-btn @click="goBack">Back</b-btn>
        <div class="next-box">
          <b-btn variant="primary"
                 @click ="preNext"
                 data-test="geo-next"
                 :disabled ="nextDisabled">Next</b-btn>
          <!--<p class="next-desc">{{nextDesc}}</p>-->
        </div>
      </div>
      </b-col>
    </b-row>
    <div class="m-tabs">
      <div v-for = "item in geoTabs.defaults"
            class = "m-tab"
            :key = "item.name" 
            :class = "{'m-tab-active': item.name === geoOption} "
             >
             <!-- :style = "{'justify-content': (item.video !== '' ? 'flex-end' : 'center' )}" -->
      <b-link
              @click='tabtargt(item)'
              :key = "item.name"
              :style = "{'margin-right': (item.video !== '' ? '2%' : '0' )}"
              >
        {{item.title}}
      </b-link>
       <a data-fancybox :href = "item.video" style="display: flex;" v-if = "item.video !== ''" >
            <img src="../../assets/images/video-play-16.png" alt="Video" />
          </a>
      </div>
      <div class="m-tab other-tab"
        :class = "{'m-tab-active': otherText !== 'Others'}"
        >
        <!-- :style = "{'justify-content': (otherVideo !== '' ? 'flex-end' : 'center' )}" -->
      <b-dropdown variant="link"
                  v-if = "geoTabs.others.length > 0"
                  :text="otherText " 
                  data-test="geo-box-other"
                  right
                  >         
                  <!-- :style = "{'margin-right': (otherVideo !== '' ? '5%' : '0' )}"          -->
        <!--<template slot="button-content">-->
          <!--<b-link  :class = "{otheractivity: otherText !== 'Others'}" style="color: #797979;">{{otherText}}</b-link>-->
        <!--</template>-->
        <b-dropdown-item v-for = "item in geoTabs.others"
                         @click='tabtargt(item)'
                         :key="item.name" >
          {{item.title}}
        </b-dropdown-item>
      </b-dropdown>
      <a data-fancybox :href = "otherVideo" style="display: flex;" v-if = "otherVideo !== ''" >
            <img src="../../assets/images/video-play-16.png" alt="Video" />
          </a>
      </div>
    </div>
    <b-container fluid>
      <b-row class="geo-box">
        <b-col>
        <slot></slot>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-alert :show="alertDesc!==''" variant="warning">{{alertDesc}}</b-alert>
        </b-col>
      </b-row>
      <b-row class="m-box-bottom">
        <div class="bootom-btn">
          <b-btn @click="goBack">Back</b-btn>
          <div class="next-box">
              <b-btn variant="primary"
                     @click ="preNext"
                     data-test="geo-next"
                     :disabled ="nextDisabled">Next</b-btn>
            <!--<p class="next-desc">{{nextDesc}}</p>-->
          </div>
        </div>

        <span v-if="datasource.geoBasedCarrierRoutes">
            * Based on postal carrier routes
          </span>
      </b-row>
    </b-container>
  </m-tab>
</template>

<script>
  import MTab from '@/components/elements/MTab'
  import _ from 'lodash'

  export default {
    components: {
      MTab
    },
    props: {
      geoOption: {
        type: String,
        default: 'zip'
      },
      title: {
        type: String
      },
      goNext: {
        type: Number,
        default: 0
      },
      needNext: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
      }
    },
    created () {
    },
    computed: {
      datasource () {
        return this.$store.getters['config/datasource']
      },
      alertDesc () {
        return this.$store.state.geo.alertDesc
      },
      geoTabs () {
        let result = {
          defaults: [],
          others: []
        }

        let tabs = this.datasource.geoTabs
        if (tabs === undefined) {
          result = []
        } else if (tabs.length <= 5) {
          result.defaults = tabs
        } else {
          result.defaults = tabs.slice(0, 4)
          result.others = tabs.slice(4)
        }
        return result
      },
      geoItems () {
        return this.$store.getters['order/geoItems']
      },
      hasDemoAndPhoneOption () {
        return this.$store.getters['order/hasDemoAndPhoneOption']
      },
      hasDemo () {
        return this.$store.getters['order/hasDemo']
      },
      nextDesc () {
        if (this.hasDemoAndPhoneOption) {
          return 'Poll Count'
        } else {
          return 'Select Audience'
        }
      },
      listType () {
        return this.$store.state.order.ListType
      },
      nextDisabled () {
        if (this.$store.state.order.CurrentStep === 'count') {
          return true
        }

        if (this.$store.state.order.GeoType === 24 && this.geoItems.length < 2) {
          return true
        }

        if ((this.$store.state.order.GeoType === 5 && this.$route.name === 'geo-moreArea') || this.$route.name === 'geo-zip' || this.$route.name === 'geo-SCFCode') {
          return false
        }
        if (this.geoItems.length === 0 && this.$store.state.order.OrderAddresses.length === 0) {
          return true
        }
        return false
      },
      otherText () {
        let index = _.findIndex(this.geoTabs.others, item => {
          return item.name === this.geoOption
        })
        if (index !== -1) {
          return this.geoTabs.others[index].title
        } else {
          return 'Others'
        }
      },
      otherVideo () {
        let index = _.findIndex(this.geoTabs.others, item => {
          return item.name === this.geoOption
        })
        if (index !== -1) {
          return this.geoTabs.others[index].video
        } else {
          return ''
        }
      }
    },
    methods: {
      preNext () {
        if (this.needNext) {
          this.$emit('go')
        } else {
          this.$store.dispatch('geo/next')
        }
      },
      goBack () {
        this.$router.push({name: 'landing'})
      },
      tabtargt (item) {
        if (item.routeName) {
          this.$store.dispatch('order/changeGeoType', item.code)
          if (item.code === 20) {
            this.$store.commit('order/addGeo', {
              GeoKeyCode: '1',
              GeoKeyDesc: 'NATIONWIDE',
              GeoType: item.code
            })
          }
          this.$router.push({name: item.routeName})
        } else {
          this.$router.push({name: 'geo-' + item.name})
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .more {
    color: $color-primary;
  }
  .content {
    padding: 1.2em 2em;
  }

  .menu {
    float: right
  }
  .header {
    display: flex;
    justify-content: space-between;
  }

  .next-desc {
    color: $color-border;
    font-size: 13px;
    margin-bottom: 0;
  }
  .next-box {
    flex-direction: column;
    display: flex;
    justify-content:center;
    align-items: center;
    margin-left: 16px;
  }
  .bootom-btn {
    display: flex;
    align-items: flex-start;
  }
  .top-btn {
    display: flex;
    align-items: flex-start;
    float: right;
  }
  .geo-box {
    margin-top: 16px;
  }
  .btn.dropdown-toggle {
    color: $color-text-grey;
  }
  .top-row {
    padding: 16px 2em 8px 0em;
  }
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/components/geo/M1GeoBox.vue